export default __webpack_public_path__ + "static/media/roundCross.7552a16a.svg";